export default __webpack_public_path__ + "static/media/thank-you.24cfa6bf.svg";